/**
 * Component for rendering links that are used in cards. Usually used as footers.
 */

import { Component, Input, Output, EventEmitter } from '@angular/core';
import { I18NDescriptor } from '../../uikit.interface';

const ICON_CHEVRON_RIGHT = 'chevron_right';

@Component({
  selector: 'va-card-link-button',
  templateUrl: './va-card-link-button.component.html',
  styleUrls: ['./va-card-link-button.component.scss'],
})
export class VaCardLinkButtonComponent {
  @Input() text: I18NDescriptor;
  @Input() iconUrl: string;
  @Input() navigationIconName?: string = ICON_CHEVRON_RIGHT;
  @Input() url?: string;
  @Output() linkClick = new EventEmitter();

  onClick(): void {
    this.linkClick.emit();
  }
}
